<template>
  <div class="home">
    <div class="imgbox">
      <!-- 最外层div设置为绝对定位 -->
      <div style="position: absolute;">
        <img class="box-img" src="../assets/banner.png">
        <div class="box-font">会员中心</div>
      </div>
    </div>
    <article class="newhome" v-cloak style="padding-bottom: 100px;">
      <div id="xieyi" style="margin-left: 20px;padding:20px; margin-top: 20px; border: 1px solid #CCCCCC;">
        <table border="0" align="center" cellpadding="0" cellspacing="0">
          <tbody>
            <tr>
              <div v-html="content"></div>
              <!-- <td style="line-height:180%">
                　　根据《福建省财政厅关于省级计算机等一般设备实行网上竞价采购有关事项的通知》要求，福建盛鑫招标代理有限公司采用网上竞价采购方式组织实施本次设备的政府采购，现邀请合格的供应商参加网上竞价。
                <br>
                　 <strong>（一）报价须知
                </strong><br>
                　　1、报价人需提供经年检合格的组织机构代码证、税务登记证、企业法人营业执照副本等复印件（原件备查），网上报价承诺书（格式见福建盛鑫招标代理有限公司“下载专区”）若非由法人本人参与竞价的，需提供法人授权委托书及授权人、被授权人身份证复印件（以上文件均需加盖公章)上传至福建盛鑫招标代理有限公司。
                <br>
                　　2、报价人报价的货物必须符合“竞价采购货物一览表”的需求，并严格按照网上竞价要求在报价文件的“报价一览表”中对货物（如技术要求、详细配置）作出明确、具体的确定性说明，不接受可选性报价（如详细配置有“可选购、大于、小于、优于”等描述都将视为无效报价），若照抄竞价文件技术要求，出现可选性报价，或经相关比对发现其描述与实际有不符或出入的，一经查实，将视为弄虚作假，其竞价无效，保证金不予退还，并按政府采购相关规定给予处罚。
                供应商中标后无法就所投产品如期供货,将视为弄虚作假，其竞价无效，保证金不予退还，并按政府采购相关规定给予处罚。
                报价人提供的货物必须是原装正品，若提供非原装正品货物，则无条件退货，并赔偿由此造成的一切损失。
                <br>
                　　3、报价文件应按福建省政府采购网上竞价文件的报价格式填写，并按网上报价要求上传（若有），未按此要求的，将被视为无效报价文件。电子报价文档具法律效力。成交人的报价文件应按竞价文件中的报价格式填写，一式二份，并盖报价单位公章和法定代表人（或授权代表）签字，在领取成交通知书时书面密封递交。<br>　
                4、报价人须提交竞价保证金伍仟元整、竞价报名费叁拾元整，各报价人应于竞价截止日前一天17:00前将保证金汇及竞价报名费入指定的保证金账户（以福建盛鑫招标代理有限公司开户银行到账凭证为准，否则视为未提交，将无法参与竞价）。未按规定提交竞价保证金和竞价报名费的报价，其竞价将被视为无效。
                <br>
                （1）保证金为报价文件的组成部分之一；
                <br>
                （2）保证金用于保护本次竞价免受报价人的行为而引起的风险；
                <br>
                （3）保证金应以银行转账的形式提交，不接受现金形式提交；
                <br>
                （4）未按规定提交竞价保证金的报价，其报价将被视为无效；
                <br>
                （5）未成交的报价人的保证金，在竞价结束后提供《退还投标保证的函》（ 格式见福建盛鑫招标代理有限公司“下载专区”）予以无息退还。
                <br>
                （6）成交报价人的报价保证金，在签订合同后，提供政府采购合同及《退还投标保证的函》，以原提交方式予以无息退还。
                <br>
                （7）成交报价人在竞价截止时间后，要求撤回或不按规定日期签订供货合同，则保证金将被没收。
                <br>　
                5、无论报价过程中的作法和结果如何，报价人自行承担所有参与报价的全部有关费用。<br>　
                6、其它要求
                <br>
                （1）报价供应商应根据竞价文件的技术要求条款，在报价文件中详细说明所提供货物的技术规格和参数、承诺质量保证期、交货期。
                <br>
                （2）上述技术规格及要求中所发生的一切费用均包含在报价价格中。
                <br>
                （3）竞价方提供的售后服务承诺以竞价一览表中的为准，竞价一览表中未体现售后服务的，均以厂家的售后服务为基础，中标方应为用户方提供最优的服务。供应商在售后服务承诺中提出更优的售后服务，但是不作为中标的条件。
                <br>
                <strong>（二）签订合同、交货时间、交货地点</strong><br>　　
                在《成交通知书》送达后，根据采购人要求在规定时间内签订合同，并按合同送货至指定地点安装调试完毕。
                <br>
                <strong>（三）报价文件应包括以下内容</strong><br>
                　　竞价承诺书、报价货物一览表、报价人资格证明文件、售后服务承诺、中标服务费承诺书及竞价项目要求提供的所有材料（按附件格式）。
                报价文件必须用A4幅面纸张打印装订，应编制封面、目录、页码，装订成册，须加盖骑缝章，并在相应位置签名并加盖公章，并在封面标明“正本”、“副本”字样。
                以上必须按本竞价文件的附件格式填写，未按格式要求填写的，其报价无效。
                <br>
                <strong>（四）竞价准则</strong><br>　　
                福建盛鑫招标代理有限公司按采购人提出的需求（详见竞价货物一览表）在
                福建盛鑫招标代理有限公司网（http://www.fjyszb.com）上公示两个工作日，同时报价人通过福建盛鑫招标代理有限公司网站按竞价文件要求在最高限价以下进行竞价，根据《福建省财政厅关于省级网上竞价采购办法的补充通知》（闽财购【2008】18号）按合同包竞价，每个品目号报价必须低于最高限价的3%（不含）以上，否则视为无效报价。在全部满足指标、供货期、售后服务需求前提下依据统一的价格要素评定最低报价,
                按价格最低者成交（报价相同者以时间先后顺序确定）。
                <br>
                <strong>（五）竞价结果确认及公告 </strong><br>
                　　网上竞价公告期满，福建盛鑫招标代理有限公司以成交结果通知书等方式书面通知采购单位。同时，将参与竞价的所有供应商的报价和中标、成交结果等信息在福建盛鑫招标代理有限公司网（http://www.fjyszb.com）上公告，采购结果公告不少于一个工作日。
                网上竞价公告期满，若无两个（含）以上不同品牌（采购单位在提出采购需求时指定品牌的，在采购单位选定的品牌范围内）供应商参与报价，或参与竞价的供应商报价不符合上述规定的，网上竞价无效，福建盛鑫招标代理有限公司以书面方式通知采购单位，采购单位调整采购需求后再进行网上竞价。



                <br>　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　
                福建盛鑫招标代理有限公司
                <br>　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　
                2011-03-01
              </td> -->
            </tr>
            <tr>
              <td height="6"></td>
            </tr>
            <tr>
              <td>
                <div align="center">
                  <tr>
                    <td height="28">
                      <div align="center">
                        <input type="radio" @click="Accept" value="1">已查看
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td height="60">
                      <div align="center" id="but1" style="display:">
                        <el-button type="primary" disabled>下一步</el-button>
                      </div>
                      <div align="center" id="but2" style="display:none">
                        <el-button type="primary" @click="start">下一步</el-button>
                      </div>
                    </td>
                  </tr>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </article>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: "Xieyi",
  components: { },
  data() {
    return {
      content: ''
    };
  },
  created() {
    this.getData();
  },
  methods: {
    Accept() {
      but2.style.display = '';
      but1.style.display = 'none';
    },
    start() {
      this.$router.replace("/UserCenter");
    },
    getData() {
      var that = this;
      this.$api.get("/Column/139", null, (r) => {
        that.content = r.response.Content;
      });
    }
  },
  watch: {
    $route(to) {
    }
  },
  computed: {

  }
};
</script>

<style>
article.newhome {
  width: 1300px;
}

.warp {
  background: #fff;
  padding-top: 20px;
  width: 100%;
  margin: 0 auto;
}

.el-table .cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

input::-webkit-input-placeholder {
  color: #999999;
  padding: 10px 0px 16px 10px;
}

.pagination {
  text-align: center;
}

.frame-border {
  width: 204px;
  border: 1px solid #EEEEEE;
}

.lmenu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #222222;
  font-size: 18px;
}</style>
